import { Grid, Divider, FormControl, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { SubjectDataVM } from 'shell/view-models/search-anpr';
import { memo, useCallback } from 'react';
import ForeignState from './foreign-state';
import ItalianState from './italian-state';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';

interface ItalianForeignStateProps {
  isForeign?: boolean;
  onChange: (key: keyof SubjectDataVM, value: SubjectDataVM[keyof SubjectDataVM]) => void;
  foreignStateBirth?: ForeignStateVM | null;
  foreignMunicipality?: MunicipalityAnprVM | null;
  provinceOfBirth?: string;
  municipalityOfBirth?: MunicipalityAnprVM | null;
  locality?: string;
  exceptionalBirthplace?: string;
  onChangeValues: (values: SubjectDataVM) => void;
  values?: SubjectDataVM;
}

const ItalianForeignStateComponent = ({
  isForeign,
  onChange,
  foreignStateBirth,
  foreignMunicipality,
  provinceOfBirth,
  municipalityOfBirth,
  values = {},
  onChangeValues,
}: ItalianForeignStateProps): React.ReactElement => {
  const resetForeign = useCallback(() => {
    onChangeValues({ ...values, foreignStateBirth: null, foreignMunicipality: null });
  }, [values, onChangeValues]);

  const resetItalian = useCallback(() => {
    onChangeValues({
      ...values,
      provinceOfBirth: '',
      municipalityOfBirth: null,
      locality: '',
      exceptionalBirthplace: '',
    });
  }, [values, onChangeValues]);

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item xs={12} md={3}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Stato"
            id="isForeign"
            value={isForeign || 'false'}
            onChange={() => onChange('isForeign', !isForeign)}
          >
            <FormControlLabel
              onClick={() => {
                resetItalian();
              }}
              value="false"
              control={<Radio />}
              label="Italiano"
            />
            <FormControlLabel
              onClick={() => {
                resetForeign();
              }}
              value="true"
              control={<Radio />}
              label="Estero"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      {isForeign ? (
        <ForeignState
          onChange={onChange}
          foreignStateBirth={foreignStateBirth}
          foreignMunicipality={foreignMunicipality}
        />
      ) : (
        <ItalianState
          onChange={onChange}
          provinceOfBirth={provinceOfBirth}
          municipalityOfBirth={municipalityOfBirth}
          birthday={values?.birthday}
        />
      )}
      <Grid item xs={12}>
        <Divider key="national-research" style={{ margin: '0 0 16px 0' }} />
      </Grid>
    </Grid>
  );
};

ItalianForeignStateComponent.displayName =
  'Filters Person section Italian or Foreign State component';

const ItalianForeignState = memo(ItalianForeignStateComponent);

export default ItalianForeignState as typeof ItalianForeignStateComponent;
